import sub from 'date-fns/sub';
import moment from 'moment';

const MOMENT_DATE_FORMAT_MMDDYYYY = 'MM/DD/YYYY';

const getMonthName = (month) => {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  if (month < 1 || month > 12) {
    return '';
  } else {
    return monthNames[month - 1];
  }
};

const aODatePickerMinDate = (months = 0, days = 0, years = 0) => {
  return sub(new Date(), {
    months,
    days,
    years,
  });
};

//
const formatDateToYYYYMMDD = (date) => moment(date).format('YYYY-MM-DD');

export { MOMENT_DATE_FORMAT_MMDDYYYY, aODatePickerMinDate, formatDateToYYYYMMDD, getMonthName };
